

export function DeveloperDashboardPage() {

  return (
    <div>
      <div className="container flex flex-col mb-2">
        <h2 className="scroll-m-20 text-2xl font-extrabold tracking-tight lg:text-3xl">
          Developer Dashboard
        </h2>


      </div>
    </div>
  );
}
